import React, { Component } from 'react';
import { Query } from 'react-apollo';

import { AuthContext } from '../../context';

import queries from '../../graphql/queries';

import QuestionHeader from '../../components/question-detail/header';
import AnswerPrompt from '../../components/question-detail/answer-prompt';
import RelatedQuestions from '../../components/question-detail/related-questions';
import NewAnswerForm from '../../components/forms/add-answer';
import PageTitle from '../../components/shared/page-title';
import SectionHeader from '../../components/shared/section-header';
import UserInfo from '../../components/shared/user-info';
import Comments from '../../components/shared/comments';
import AnswerBody from '../../components/answer-detail/answer-body';
import AnswerActions from '../../components/answer-detail/answer-actions';

import style from './index.module.scss';

const {
  questionQueries: { QUESTION_BY_ID },
} = queries;

class QuestionDetail extends Component {
  static contextType = AuthContext;

  state = {
    isAnswerFormDisplayed: false,
  };

  onDisplayAnswerForm = () => {
    this.setState({
      isAnswerFormDisplayed: !this.state.isAnswerFormDisplayed,
    });
  };

  render() {
    const { isAnswerFormDisplayed } = this.state;
    const {
      match: {
        params: { questionTitle },
      },
      location: {
        state: { questionId },
      },
    } = this.props;
    const { currentUser } = this.context;

    const formatAnswerListLabel = answerList => {
      if (answerList.length === 0) {
        return 'No answers yet';
      } else if (answerList.length === 1) {
        return '1 answer';
      } else {
        return `${answerList.length} answers`;
      }
    };

    // Check if current user has already answered question
    const hasAnswered = answerList => {
      return answerList
        .map(answer => answer.addedBy.id)
        .includes(currentUser.id);
    };

    return (
      <>
        <PageTitle
          pageTitle={`Quora - ${questionTitle}`}
          pageDesc="Question detail page of Quora"
        />
        <Query query={QUESTION_BY_ID} variables={{ questionId }}>
          {({ loading, error, data }) => {
            if (loading) return <div>Loading...</div>;
            if (error) return <div>Error!</div>;

            const { questionById } = data;

            return (
              <div className={`row ${style['question-detail']}`}>
                <div className={`col ${style['col--main']}`}>
                  <header className={`row ${style['row--header']}`}>
                    <QuestionHeader
                      question={questionById}
                      displayAnswerForm={this.onDisplayAnswerForm}
                    />
                  </header>
                  {isAnswerFormDisplayed && (
                    <NewAnswerForm questionId={questionById.id} />
                  )}
                  {!isAnswerFormDisplayed &&
                    !hasAnswered(questionById.answers) && (
                      <AnswerPrompt
                        currentUser={currentUser}
                        displayAnswerForm={this.onDisplayAnswerForm}
                      />
                    )}
                  <section className={`row ${style['row--answers']}`}>
                    <div className={style['section-header']}>
                      <SectionHeader
                        headingLeft={formatAnswerListLabel(
                          questionById.answers
                        )}
                        colWidth={12}
                      />
                    </div>
                    <div className={style['answer-list']}>
                      {questionById.answers.map(answer => (
                        <div className={style.answer} key={answer.id}>
                          <UserInfo
                            user={answer.addedBy}
                            dates={{
                              createdAt: answer.createdAt,
                              updatedAt: answer.updatedAt,
                            }}
                          />
                          <AnswerBody answerBody={answer.body} />
                          <AnswerActions answer={answer} />
                          <Comments
                            answerId={answer.id}
                            commentList={answer.comments}
                          />
                        </div>
                      ))}
                    </div>
                  </section>
                </div>
                <div className={`col ${style['col--related-questions']}`}>
                  <RelatedQuestions />
                </div>
              </div>
            );
          }}
        </Query>
      </>
    );
  }
}

export default QuestionDetail;
